import { Basket, VariationDetails } from '~/lib/data-contract';

export enum MiniBasketStoreSuggestionStatus {
    IDLE = 'idle',
    LOADING = 'loading',
    SUCCESS = 'success',
    ERROR = 'error',
}

export type BasketUIState = {
    isMiniBasketOpen: boolean;
    miniBasketStoreSuggestionName: string | null;
    miniBasketStoreSuggestionError: string | null;
    toggleMiniBasket: (open: boolean) => void;
    setMiniBasketStoreSuggestionName: (storeName: string | null) => void;
    setMiniBasketStoreSuggestionError: (message: string | null) => void;
    miniBasketStoreSuggestionStatus: MiniBasketStoreSuggestionStatus;
    setMiniBasketStoreSuggestionStatus: (status: MiniBasketStoreSuggestionStatus) => void;
};

export type BasketAPIActions = {
    /** Adds an item to the basket */
    addItem: (variant: VariationDetails, quantity: number) => void;
    /** Removes an item from the basket */
    removeItem: (variant: VariationDetails) => void;
    /** Updates the quantity of an existing item in the basket */
    updateItem: (variant: VariationDetails, quantity: number) => void;
};

export type BasketAPIState = {
    isLoading: boolean;
    isStale: boolean;
    isError: boolean;
    error: unknown;
};

export type BasketShared = BasketUIState &
    BasketAPIActions &
    BasketAPIState & {
        data?: Basket;
    };

export type UseBasket = () => BasketShared;
